import React from "react";

import { FormattedMessage } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";
import MainBreadcrumb from "react-bootstrap/Breadcrumb";

import useWindowDimensions from "../../hooks/useWindowDimensions";
import { ReactComponent as IconAnchorLeft18 } from "../../icons/icon/18/a-icon-anchor-left-18.svg";
import { ReactComponent as IconBigHome18 } from "../../icons/icon/18/a-icon-bighome-18.svg";
import { ReactComponent as IconHome18 } from "../../icons/icon/18/a-icon-home-18.svg";
import AdaptiveIcon from "../adaptiveIcon/adaptiveIcon";

import "./breadcrumb.scss";

const Breadcrumb = ({
  items = [],
  withHomeIcon = true,
}) => {
  const { width } = useWindowDimensions();

  return (
    <MainBreadcrumb className="breadcrumb-container">
      {
        // width === 0 for initial build
        width === 0 || width > 576 || items.length < 3
          ? (
            <>
              {withHomeIcon && (
                <MainBreadcrumb.Item
                  className="typo-small-label breadcrumb__home"
                  href="/"
                  active={items.length === 0}
                >
                  <AdaptiveIcon
                    sm={<IconBigHome18 />}
                    lg={<IconHome18 />}
                  />
                </MainBreadcrumb.Item>
              )}
              {items.map((item, i) => (
                <MainBreadcrumb.Item
                  active={i + 1 === items.length}
                  className="typo-small-label"
                  href={item.link}
                  key={item.title}
                >
                  {item.title}
                </MainBreadcrumb.Item>
              ))}
            </>
          )
          : (
            <MainBreadcrumb.Item
              className="typo-small-label"
              href={items[items.length - 2].link}
            >
              <span><IconAnchorLeft18 /></span><FormattedMessage id="breadcrumb.view" /> {items[items.length - 2].title}
            </MainBreadcrumb.Item>
          )
      }
    </MainBreadcrumb>
  );
};

Breadcrumb.propTypes = {
  items: PropTypes.oneOfType([PropTypes.array]),
  withHomeIcon: PropTypes.bool,
};

export default Breadcrumb;
